const REFERRAL_BASE_URL = 'https://lp.shore.com';

const referralLinks: { [key: string]: string } = {
  de: '/de/pos-jetzt_empfehlen/',
  en: '/en/refer-pos-now/',
  es: '/es/recomienda-pos/',
};

const shorePayPlanLinks: { [key: string]: string } = {
  de: '/de/shore-pay-einheitstarif-pos/',
  en: '/en/shore-pay-flat-rate-pos/',
  es: '/en/shore-pay-flat-rate-pos/',
};

const getReferralLink = (locale: string) =>
  `${REFERRAL_BASE_URL}${referralLinks[locale] || referralLinks.de}`;

const getShorepayNewPlanLink = (locale: string) =>
  `${REFERRAL_BASE_URL}${shorePayPlanLinks[locale] || shorePayPlanLinks.de}`;

export { getReferralLink, getShorepayNewPlanLink };
